import React from 'react';

function wrapperStyle({ styles, constants }) {
  const style = {
    ...styles.centerStyle,
    paddingTop: constants.KEYCONTROL_WRAPPER_PADDING_TOP,
    paddingBottom: constants.KEYCONTROL_WRAPPER_PADDING_BOTTOM
  };

  return style;
}

function buttonStyle({ styles, constants, color }) {
  const style = {
    ...styles.fontStyle,
    height: constants.KEYCONTROL_BUTTON_HEIGHT,
    fontSize: constants.KEYCONTROL_BUTTON_FONT_SIZE,
    lineHeight: `${constants.KEYCONTROL_BUTTON_HEIGHT}px`,
    borderRadius: constants.KEYCONTROL_BUTTON_HEIGHT / 2,
    backgroundColor: color.white,
    fontWeight: 900,
    color: color.grey['600'],
    paddingRight: constants.KEYCONTROL_BUTTON_PADDING_HORIZONTAL,
    paddingLeft: constants.KEYCONTROL_BUTTON_PADDING_HORIZONTAL,
    border: `1px solid ${color.grey['400']}`
  };

  return style;
}
export default props => (
  <div style={wrapperStyle(props)}>
    <div
      style={buttonStyle(props)}
      onClick={props.redirect}
      onKeyPress={props.redirect}
      tabIndex={0}
      role="button"
    >
      {props.text.SIGN_KEYCONTROL_BUTTON}
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/KeyControl/index.js